<template>
  <tr class=" transition-colors duration-150 ease-in-out text-right child:py-4 first-child:pl-16 last-child:pr-3 text-sm">
    <td
      class="py-3 text-left"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.sharedFundCode') + ': ' + $props.sharedFund.code + ', ' + $t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.sharedFundName') + ': ' + $props.sharedFund.name"
    >
      <div class="flex items-start space-x-2">
        <span class="font-semibold text-gray-900 flex-shrink-0">{{ sharedFund.code }}</span>

        <p class="text-gray-700">
          {{ sharedFund.name }}
        </p>
      </div>
    </td>

    <td
      class="pr-3"
      :title="showBudgetCommentTooltip ? varianceComment.body : ''"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.budgetAmount') + ': ' + australianCurrency(sharedFund.budget) + (showBudgetCommentTooltip ? ', ' + varianceComment.body : '')"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showBudgetCommentButton"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          :aria-label="varianceComment ? $t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.editComment') : $t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.addComment')"
          @click.stop="editBudgetComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <button
          v-else-if="!!varianceComment?.body"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          @click.stop="showBudgetcomment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          {{ australianCurrency(sharedFund.budget) }}
        </div>
      </div>
    </td>

    <td class="bg-green-100/50" />

    <template v-if="claim.capture_claim_amount">
      <td
        v-if="!falsey(sharedFundCost?.current_claim) && !typingClaim && canEditClaim"
        :class="{ 'cursor-pointer': canEditClaim }"
        class="bg-green-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.currentClaim') + ': ' + (sharedFundCost.current_claim ? australianCurrency(sharedFundCost.current_claim) : '')"
        @click="typeClaim"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.removeClaim')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            v-if="canEditClaim"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.editClaim')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(sharedFundCost.current_claim) ? australianCurrency(sharedFundCost.current_claim) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditClaim"
        class="bg-green-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.currentClaim') + ': ' + $t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.editClaim')"
      >
        <div class="flex justify-end">
          <AppCurrencyInput
            ref="claimInput"
            v-model.number="costForm.form.current_claim"
            name="current_claim"
            type="number"
            min="1"
            class="w-20 h-6 form-input"
            @blur="stopTypingClaim"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="typingClaim = false"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-green-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.currentClaim') + ': ' + (sharedFundCost?.current_claim ? australianCurrency(sharedFundCost.current_claim) : '')"
      >
        {{ !falsey(sharedFundCost?.current_claim) ? $tcc(sharedFundCost.current_claim) : '' }}
      </td>
    </template>

    <td class="bg-green-100/50" />

    <td
      v-if="!falsey(sharedFundCost?.current_certified) && !typingCertified && canEditCertified"
      :class="{ 'cursor-pointer': canEditCertified }"
      class="bg-green-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.currentCertified') + ': ' + (sharedFundCost.current_certified ? australianCurrency(sharedFundCost.current_certified) : '')"
      @click="typeCertified"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.removeCertified')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
            @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          v-if="canEditCertified"
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.editCertified')"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ !falsey(sharedFundCost.current_certified) ? australianCurrency(sharedFundCost.current_certified) : '' }}
      </div>
    </td>

    <td
      v-else-if="canEditCertified"
      class="bg-green-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.currentCertified') + ': ' + $t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.editCertified')"
    >
      <div class="flex justify-end">
        <AppCurrencyInput
          ref="certifiedInput"
          v-model.number="costForm.form.current_certified"
          name="current_certified"
          type="number"
          min="1"
          class="w-20 h-6 form-input"
          @blur="stopTypingCertified"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingCertified = false"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-green-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.currentCertified') + ': ' + (sharedFundCost?.current_certified ? australianCurrency(sharedFundCost.current_certified) : '')"
    >
      {{ sharedFundCost?.current_certified ? australianCurrency(sharedFundCost.current_certified) : '' }}
    </td>

    <td
      v-if="claim.capture_claim_amount"
      class="group bg-green-100/50"
      :class="{ 'text-red-600': hasVariance && variance !== 0 }"
      :title="hasVariance && variance !== 0 && varianceComment?.body ? varianceComment.body : ''"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.varianceAmount') + ': ' + (hasVariance ? australianCurrency(variance) : '') + (hasVariance && variance !== 0 && varianceComment?.body ? ', ' + $t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.varianceTooltip') + ': ' + varianceComment.body : '')"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showCommentButton"
          type="button"
          class="btn-icon group-hover:visible btn-icon-default invisible mr-1 shrink-0"
          aria-label="Edit variance comment"
          @click.stop="editVarianceComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          {{ hasVariance ? australianCurrency(variance) : '' }}
        </div>
      </div>
    </td>

    <td
      class="bg-green-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.previousAmount') + ': ' + australianCurrency(previousAmount)"
    >
      {{ australianCurrency(previousAmount) }}
    </td>

    <td
      class="bg-green-100/50 pr-3"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.cumulativeAmount') + ': ' + australianCurrency(cumulativeAmount)"
    >
      {{ australianCurrency(cumulativeAmount) }}
    </td>

    <template v-if="claim.capture_claim_amount">
      <td
        v-if="showPercentages && !falsey(sharedFundCost?.current_claim) && !typingClaim && canEditClaim && sharedFund.budget"
        :class="{ 'cursor-pointer': canEditClaim }"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.claimPercentage') + ': ' + (sharedFundCost?.current_claim ? `${$tn((sharedFundCost.current_claim / sharedFund.budget) * 100)}%` : '')"
        @click="typeClaimPercent"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.removeClaim')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            v-if="canEditClaim"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.editClaim')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(sharedFundCost?.current_claim) ? $tp(Math.abs(sharedFundCost.current_claim / sharedFund.budget) * 100) : '' }}
        </div>
      </td>

      <td
        v-else-if="showPercentages && canEditClaim && sharedFund.budget"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.claimPercentage') + ': ' + $t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.editClaim')"
      >
        <div class="flex justify-end">
          <AppInput
            ref="claimPercentInput"
            v-model.number="currentClaimPercent"
            name="current_claim_percent"
            type="number"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingClaim"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="typingClaim = false"
          />
        </div>
      </td>

      <td
        v-else-if="showPercentages"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.claimPercentage') + ': ' + (sharedFundCost?.current_claim && sharedFund.budget ? `${$tn((sharedFundCost.current_claim / sharedFund.budget) * 100)}%` : '')"
      >
        {{ !falsey(sharedFundCost?.current_claim) && sharedFund.budget ? $tp(Math.abs(sharedFundCost.current_claim / sharedFund.budget) * 100) : '' }}
      </td>

      <td
        v-else
        class="bg-blue-100/50"
      />
    </template>

    <td
      v-if="showPercentages && !falsey(sharedFundCost?.current_certified) && !typingCertified && canEditCertified && sharedFund.budget"
      :class="{ 'cursor-pointer': canEditCertified }"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.certifiedPercentage') + ': ' + (sharedFundCost?.current_certified && sharedFund.budget ? `${$tn((sharedFundCost.current_certified / sharedFund.budget) * 100)}%` : '')"
      @click="typeCertifiedPercent"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.removeCertified')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
            @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          v-if="canEditCertified"
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.editCertified')"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ !falsey(sharedFundCost?.current_certified) && sharedFund.budget ? $tp(Math.abs(sharedFundCost.current_certified / sharedFund.budget) * 100) : '' }}
      </div>
    </td>

    <td
      v-else-if="showPercentages && canEditCertified && sharedFund.budget"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.certifiedPercentage') + ': ' + $t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.editCertified')"
    >
      <div class="flex justify-end">
        <AppInput
          ref="certifiedPercentInput"
          v-model.number="currentCertifiedPercent"
          name="current_certified_percent"
          type="number"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingCertified"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingCertified = false"
        />
      </div>
    </td>

    <td
      v-else-if="showPercentages"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.certifiedPercentage') + ': ' + (sharedFundCost?.current_certified && sharedFund.budget ? `${$tn((sharedFundCost.current_certified / sharedFund.budget) * 100)}%` : '')"
    >
      {{ !falsey(sharedFundCost?.current_certified) && sharedFund.budget ? $tp(Math.abs(sharedFundCost.current_certified / sharedFund.budget) * 100) : '' }}
    </td>

    <td
      v-else-if="!claim.capture_claim_amount"
      class="bg-blue-100/50"
    />

    <td
      v-if="showPercentages"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.previousPercentage') + ': ' + (sharedFund.budget ? $tp((previousAmount / sharedFund.budget) * 100) : '')"
    >
      {{ sharedFund.budget ? $tp(Math.abs(previousAmount / sharedFund.budget) * 100) : '' }}
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50 pr-3"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.cumulativePercentage') + ': ' + (sharedFund.budget ? $tp((cumulativeAmount / sharedFund.budget) * 100) : '')"
    >
      {{ sharedFund.budget ? $tp(Math.abs(cumulativeAmount / sharedFund.budget) * 100) : '' }}
    </td>

    <td
      class="pr-3"
      :aria-label="$t('HeadContract.ProgressClaimsLite.SharedFundCostRow.accessibility.remainingBudget') + ': ' + (sharedFund.budget ? australianCurrency(sharedFund.remaining(claim, currentCertified)) : '')"
    >
      {{ sharedFund.budget ? australianCurrency(sharedFund.remaining(claim, currentCertified)) : '' }}
    </td>
  </tr>
</template>

<script setup lang="ts">
import { useFormData } from '@/composables/useFormData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency, falsey, roundDecimals } from '@/helpers';
import { t } from '@/i18n';
import Claim, { ClaimStatus } from '@/models/Claim';
import SharedFund from '@/models/SharedFund';
import { useSharedFundCostsStore } from '@/store/sharedFundCosts';
import { useUserStore } from '@/store/user';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, watch } from 'vue';
import { toast } from 'vue3-toastify';

const props = defineProps<{
  sharedFund: SharedFund;
  claim: Claim;
  showPercentages: boolean;
}>();

const sharedFundCostsStore = useSharedFundCostsStore();
const userStore = useUserStore();
const createSharedFundCostAction = useStoreApiAction(sharedFundCostsStore.createSharedFundCost);
const updateSharedFundCostAction = useStoreApiAction(sharedFundCostsStore.updateSharedFundCost);
const updateCommentAction = useStoreApiAction(sharedFundCostsStore.updateComment);
const deleteCommentAction = useStoreApiAction(sharedFundCostsStore.deleteComment);
const deleteSharedFundCostAction = useStoreApiAction(sharedFundCostsStore.deleteSharedFundCost);

const sharedFundCost = computed(() => {
  return sharedFundCostsStore.models.with('comments')
    .where('shared_fund_id', props.sharedFund.id)
    .where('claim_id', props.claim.id)
    .first();
});

const canEditCertified = computed(() => {
  return props.claim.status === ClaimStatus.draft &&
    userStore.hasAccessToRoute('ProgressClaims');
});

const canEditClaim = computed(() => {
  return props.claim.status === ClaimStatus.draft &&
    userStore.hasAccessToRoute('ProgressClaims');
});

const typingCertified = ref(falsey(sharedFundCost.value?.current_certified));
const typingClaim = ref(falsey(sharedFundCost.value?.current_claim));
const certifiedInput = ref();
const certifiedPercentInput = ref();
const claimInput = ref();
const claimPercentInput = ref();

const costForm = useFormData({
  current_certified: undefined,
  current_claim: undefined,
  comment: undefined,
});

const previousAmount = computed(() => props.sharedFund.previous(props.claim));
const currentCertified = computed(() => sharedFundCost.value?.current_certified ?? 0);
const cumulativeAmount = computed(() => previousAmount.value + currentCertified.value);

const variance = computed(() => {
  return sharedFundCost.value?.current_claim - sharedFundCost.value?.current_certified;
});

const hasVariance = computed(() => {
  return !falsey(sharedFundCost.value?.current_claim) && !falsey(sharedFundCost.value?.current_certified);
});

const currentCertifiedPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_certified / props.sharedFund.budget) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.sharedFund.budget * 100) === 100) {
      costForm.form.current_certified = props.sharedFund.budget - previousAmount.value;

      return;
    }

    costForm.form.current_certified = roundDecimals((value / 100) * props.sharedFund.budget);
  },
});

const currentClaimPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_claim / props.sharedFund.budget) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.sharedFund.budget * 100) === 100) {
      costForm.form.current_claim = props.sharedFund.budget - previousAmount.value;

      return;
    }

    costForm.form.current_claim = roundDecimals((value / 100) * props.sharedFund.budget);
  },
});

watch(sharedFundCost, (cost) => {
  if(cost) {
    costForm.setData(cost);
  }
}, { immediate: true });

const typeCertified = () => {
  if(canEditCertified.value) {
    typingCertified.value = true;

    if(sharedFundCost.value) {
      costForm.form.current_certified = sharedFundCost.value.current_certified;
    }

    nextTick(() => {
      certifiedInput.value?.focusInput();
    });
  }
};

const typeCertifiedPercent = () => {
  if(canEditCertified.value) {
    typingCertified.value = true;

    if(sharedFundCost.value) {
      costForm.form.current_certified = sharedFundCost.value.current_certified;
    }

    nextTick(() => {
      certifiedPercentInput.value?.focusInput();
    });
  }
};

const typeClaim = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    if(sharedFundCost.value) {
      costForm.form.current_claim = sharedFundCost.value.current_claim;
    }

    nextTick(() => {
      claimInput.value?.focusInput();
    });
  }
};

const typeClaimPercent = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    if(sharedFundCost.value) {
      costForm.form.current_claim = sharedFundCost.value.current_claim;
    }

    nextTick(() => {
      claimPercentInput.value?.focusInput();
    });
  }
};

const stopTypingClaim = async () => {
  if(
    (falsey(costForm.form.current_claim) && !sharedFundCost.value) ||
    !typingClaim.value
  ) {
    return;
  }

  if(
    sharedFundCost.value &&
    falsey(costForm.form.current_claim) &&
    falsey(sharedFundCost.value.current_certified)
  ) {
    deleteSharedFundCostAction.request(sharedFundCost.value.id).then(() => {
      typingClaim.value = true;
    }).catch((_error) => {
      Swal.fire({
        icon: 'error',
        title: t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.somethingWentWrong'),
      });

      typingClaim.value = false;
    });
  } else if(sharedFundCost.value) {
    costForm.resetData(['comment']);

    if(
      !falsey(sharedFundCost.value.current_certified) &&
      costForm.form.current_claim !== sharedFundCost.value.current_certified
    ) {
      const comment = await Swal.fire({
        icon: 'warning',
        title: t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.reasonForAdjustment'),
        text: t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.varianceReasonText'),
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
      });

      costForm.form.comment = comment?.value;
    }

    updateSharedFundCostAction.request(sharedFundCost.value.id, {
      current_claim: costForm.form.current_claim,
      comment: costForm.form.comment,
    })
      .then((_sharedFundCost) => {
        if(falsey(sharedFundCost.value.current_claim)) {
          typingClaim.value = true;
        } else {
          typingClaim.value = false;
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: error.status === 422 ?
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.invalidData') :
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.somethingWentWrong'),

          text: error.data?.message,
        });

        costForm.form.current_claim = sharedFundCost.value.current_claim;
        typingClaim.value = false;
      });
  } else {
    createSharedFundCostAction.request(props.claim.id, props.sharedFund.id, costForm.only(['current_claim']))
      .then((_sharedFundCost) => {
        typingClaim.value = false;
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: error.status === 422 ?
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.invalidAmount') :
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.somethingWentWrong'),

          text: error.data?.message,
        });

        typingClaim.value = true;
      });
  }
};

const stopTypingCertified = async () => {
  if(
    (falsey(costForm.form.current_certified) && !sharedFundCost.value) ||
    !typingCertified.value
  ) {
    return;
  }

  if(
    falsey(costForm.form.current_certified) && sharedFundCost.value &&
    falsey(sharedFundCost.value.current_claim)
  ) {
    deleteSharedFundCostAction.request(sharedFundCost.value.id).then(() => {
      typingCertified.value = true;
    }).catch((_error) => {
      typingCertified.value = false;
    });
  } else if(sharedFundCost.value) {
    costForm.resetData(['comment']);

    if(
      props.claim.capture_claim_amount &&
      !falsey(sharedFundCost.value.current_claim) &&
      costForm.form.current_certified !== sharedFundCost.value.current_claim
    ) {
      const comment = await Swal.fire({
        icon: 'warning',
        title: t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.reasonForAdjustment'),
        text: t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.varianceReasonText'),
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
      });

      costForm.form.comment = comment?.value;
    }

    updateSharedFundCostAction.request(sharedFundCost.value.id, {
      current_certified: costForm.form.current_certified,
      comment: costForm.form.comment,
    }).then((_sharedFundCost) => {
      if(falsey(sharedFundCost.value?.current_certified)) {
        typingCertified.value = true;
      } else {
        typingCertified.value = false;
      }
    }).catch((error) => {
      Swal.fire({
        icon: 'error',
        title: error.status === 422 ?
          t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.invalidData') :
          t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.somethingWentWrong'),

        text: error.data?.message,
      });

      costForm.form.current_certified = sharedFundCost.value.current_certified;
      typingCertified.value = false;
    });
  } else {
    createSharedFundCostAction.request(props.claim.id, props.sharedFund.id, costForm.only(['current_certified']))
      .then((_sharedFundCost) => {
        typingCertified.value = false;
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: error.status === 422 ?
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.invalidAmount') :
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.somethingWentWrong'),

          text: error.data?.message,
        });

        typingCertified.value = true;
      });
  }
};

const deleteCost = () => {
  deleteSharedFundCostAction.request(sharedFundCost.value.id).then(() => {
    costForm.form.current_certified = undefined;
    costForm.form.current_claim = undefined;
    typingCertified.value = true;
    typingClaim.value = true;
  });
};

const removeClaim = () => {
  if(falsey(sharedFundCost.value.current_certified)) {
    deleteCost();
  } else {
    updateSharedFundCostAction.request(sharedFundCost.value.id, { current_claim: undefined })
      .then((_sharedFundCost) => {
        typingClaim.value = true;
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: error.status === 422 ?
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.invalidAmount') :
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.somethingWentWrong'),

          text: error.data?.message,
        });

        costForm.form.current_claim = sharedFundCost.value.current_claim;
      });
  }
};

const removeCertified = () => {
  if(falsey(sharedFundCost.value.current_claim)) {
    deleteCost();
  } else {
    updateSharedFundCostAction.request(sharedFundCost.value.id, { current_certified: undefined })
      .then((_sharedFundCost) => {
        typingCertified.value = true;
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: error.status === 422 ?
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.invalidAmount') :
            t('HeadContract.ProgressClaimsLite.SharedFundCostRow.error.somethingWentWrong'),

          text: error.data?.message,
        });

        costForm.form.current_certified = sharedFundCost.value.current_certified;
      });
  }
};

const varianceComment = computed(() => {
  return sharedFundCost.value?.comments?.[0];
});

const isOptionalComment = computed(() => {
  if(!sharedFundCost.value) {
    return false;
  }

  if(!props.claim.capture_claim_amount) {
    return !falsey(sharedFundCost.value.current_certified);
  }

  const claim = sharedFundCost.value.current_claim;
  const certified = sharedFundCost.value.current_certified;

  if(falsey(claim) || falsey(certified)) {
    return false;
  }

  return claim === certified;
});

const showCommentButton = computed(() => {
  return hasVariance.value && variance.value !== 0 && !!varianceComment.value && canEditCertified.value;
});

const showBudgetCommentButton = computed(() => {
  return canEditCertified.value &&
    !falsey(sharedFundCost.value) &&
    !falsey(sharedFundCost.value.current_certified) &&
    (props.claim.capture_claim_amount ? !falsey(sharedFundCost.value.current_claim) : true);
});

const showBudgetCommentTooltip = computed(() => {
  return !!varianceComment.value?.body && showBudgetCommentButton.value;
});

const showBudgetcomment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ?
      t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.reasonForAdjustment') :
      t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.commentTitle'),

    text: varianceComment.value?.body,
  });
};

const editBudgetComment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ?
      t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.reasonForAdjustment') :
      t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.commentTitle'),

    text: (hasVariance.value && variance.value !== 0) ?
      t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.varianceReasonText') :
      t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.commentText'),

    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: varianceComment.value ? 'Update' : 'Save',
    showDenyButton: isOptionalComment.value && !!varianceComment.value,
    denyButtonText: 'Delete',
    denyButtonColor: '#d33',
  }).then((result) => {
    if(result.isDenied && varianceComment.value) {
      deleteCommentAction.request(sharedFundCost.value.id, varianceComment.value.id).then(() => {
        toast.success('Comment deleted');
      });
    } else if(result.isConfirmed && result.value) {
      if(varianceComment.value) {
        updateCommentAction.request(sharedFundCost.value.id, varianceComment.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment updated');
          },
        );
      } else {
        updateSharedFundCostAction.request(sharedFundCost.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment saved');
          },
        );
      }
    }
  });
};

const editVarianceComment = () => {
  Swal.fire({
    icon: 'warning',
    title: t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.reasonForAdjustment'),
    text: t('HeadContract.ProgressClaimsLite.SharedFundCostRow.dialog.varianceReasonText'),
    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: 'Update',
  }).then((result) => {
    if(result.isConfirmed) {
      if(result.value) {
        updateCommentAction.request(sharedFundCost.value.id, varianceComment.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment updated');
          },
        );
      }
    }
  });
};
</script>
